<template>
  <v-container>
    <loading
      :active="loader"
      :is-full-page="true"
      :opacity="0.9"
      color="#ff6b00"
    />
    <v-alert
      v-if="alertMsg.status"
      :timeout="alertMsg.timeout"
      :color="alertMsg.color"
      :type="alertMsg.type"
      dismissible
    >
      {{ alertMsg.text }}
    </v-alert>
    <v-row>
      <v-col cols="12" md="6">
        <p class="font-weight-bold text-h5">{{ selctedEntity }}:</p>
      </v-col>
      <v-col cols="12" md="6" v-if="allSets.includes(selctedEntity)">
        <v-radio-group v-model="docUploadType" row>
          <v-radio
            :label="$t('all_docs_together')"
            color="primary"
            value="alldocs"
          ></v-radio>
          <v-radio
            :label="$t('individual_docs')"
            color="primary"
            value="individualdocs"
          ></v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
    <v-row v-for="doc in EntityDocs" :key="doc.doc_name.name">
      <v-col cols="12" md="8">
        {{ doc.doc_name.name }}
        <span
          v-if="isDocumentRequired(doc) && doc.doc_name.value_code !== '7'"
          style="color: #f00"
          >*</span
        >
      </v-col>
      <v-btn
        v-if="doc.doc_url"
        color="primary"
        small
        outlined
        class="ma-2"
        @click="viewDoc(doc)"
      >
        View
      </v-btn>
      <v-btn
        v-if="doc.doc_url"
        color="success"
        fab
        small
        class="ma-2"
        aria-label="Download document"
        @click="openDoc(doc.doc_url)"
      >
        <v-icon>mdi-file-download</v-icon>
      </v-btn>

      <v-menu
        v-model="doc.isactive"
        :close-on-content-click="false"
        fixed
        :nudge-width="400"
        offset-x
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            class="ma-2"
            dark
            v-bind="attrs"
            v-on="on"
            fab
            small
          >
            <v-icon dark small>
              {{ doc.doc_url ? "mdi-pencil" : "mdi-cloud-upload" }}</v-icon
            >
          </v-btn>
        </template>

        <v-card>
          <v-form ref="uploadDoc">
            <v-col cols="12"
              >{{ doc.doc_name.name
              }}<span
                v-if="isDocumentRequired(doc) && doc.doc_name.value_code !== '7'"
                style="color: #f00"
                >*</span
              >
            </v-col>
            <v-col cols="12">
              <v-file-input
                v-model="doc.doc_val"
                dense
                accept=".pdf,.docx,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,image/png,image/jpeg,image/gif,image/webp,image/bmp,image/svg+xml"
                :placeholder="$t('upload_file')"
                :error-messages="isDocumentRequired(doc) ? docError : ''"
                outlined
                :required="isDocumentRequired(doc)"
                prepend-icon=""
                @change="fileUpload($event, doc)"
              >
                <template v-slot:append>
                  <v-icon aria-hidden="false" class="color-primary">
                    mdi-cloud-upload
                  </v-icon>
                </template>
              </v-file-input>
            </v-col>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn text @click="doc.isactive = false">
                {{ $t("cancel_label") }}</v-btn
              >
              <v-btn color="primary" text @click="uploadDocument(doc)">
                {{ $t("save") }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-menu>
    </v-row>
    <v-dialog
      v-model="isDocumentPreviewOpen"
      max-width="900"
      scrollable
      @input="onPreviewDialogChange"
    >
      <v-card>
        <v-card-title>{{ previewDocName }}</v-card-title>

        <v-card-text class="document-preview-container">
          <div v-if="previewLoading" class="pa-4">Loading preview...</div>
          <v-alert
            v-else-if="previewError"
            type="warning"
            outlined
            class="ma-4"
          >
            {{ previewError }}
          </v-alert>
          <img
            v-else-if="previewType === 'image'"
            :src="previewDocUrl"
            :alt="previewDocName"
            class="preview-image"
            @error="handleImagePreviewError"
          />
          <iframe
            v-else-if="previewType === 'pdf'"
            :src="previewDocUrl"
            :title="previewDocName"
            class="preview-pdf"
          ></iframe>
          <div
            v-else-if="previewType === 'docx'"
            class="preview-word"
            v-html="previewHtml"
          ></div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="previewType === 'pdf' && previewDocUrl"
            text
            color="primary"
            :href="previewDocUrl"
            target="_blank"
            rel="noopener noreferrer"
          >
            Open in new tab
          </v-btn>
          <v-btn text @click="closePreview">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { webbreakdown } from "../../utils/breakpoints";
import Loading from "vue-loading-overlay";
import { IndbusinessDocs, SetbusinessDocs } from "../../utils/BusDocuments";
import AgentService from "@/services/agentService/AgentService";
import mammoth from "mammoth";
import DOMPurify from "dompurify";
export default {
  data: () => ({
    webbreakdown,
    businessDocument: IndbusinessDocs(),
    SetBusinessdocs: SetbusinessDocs(),
    allSets: [
      "Private Limited Companies (Sdn Bhd)",
      "Sole-Proprietorship/Partnership",
      "Limited Liability Partnership",
    ],

    showPopup: false,
    EntityDocs: [],
    loader: false,
    dialog: false,
    isshowdoc: false,
    SelectedSrc: null,
    isDocumentPreviewOpen: false,
    previewDocName: "",
    previewDocUrl: "",
    previewType: "",
    previewHtml: "",
    previewLoading: false,
    previewError: "",
    previewObjectUrl: "",
    previewRequestId: 0,
    documentsRequestId: 0,
    EntityName: "",
    document_name: null,
    docError: "",
    docUploadType: "alldocs",
    alertMsg: {
      status: false,
      text: "",
      timeout: 2000,
      color: "blue-grey",
      type: "info",
    },
    selectedDoc: {},
    docsupload: {},
    recievedDocs: [],
    menu: false,
    error: false,
    docrules: [(v) => !!v || "Document is required"],
  }),
  components: {
    Loading,
  },
  name: "BankDetails",
  props: {
    isActive: {
      type: Boolean,
      default: true,
    },
    selctedEntity: {
      type: String,
    },
    hideForm: {
      type: String,
    },
  },

  validations() {},
  watch: {
    isActive(active) {
      if (active) this.getuploads();
    },
    selctedEntity: {
      handler(newval) {
        this.docUploadType = "alldocs";
        this.EntityName = newval;
        this.returnBusinessDocs(newval, this.SetBusinessdocs);
        this.getuploads();

      },
    },
    hideForm: {
      handler(newval) {
        if (
          newval &&
          this.EntityName === "Private Limited Companies (Sdn Bhd)"
        ) {
          this.docUploadType = "alldocs";
          this.returnBusinessDocs(this.EntityName, this.SetBusinessdocs);
          this.getuploads();
        }
      },
    },
    docUploadType(val) {
      if (val === "alldocs") {
        this.returnBusinessDocs(this.selctedEntity, this.SetBusinessdocs);
      } else {
        this.returnBusinessDocs(this.selctedEntity, this.businessDocument);
      }
      this.getuploads();
    },
  },
  mounted() {
    this.returnBusinessDocs(this.selctedEntity, this.SetBusinessdocs);
    this.getuploads();
  },
  beforeDestroy() {
    this.previewRequestId++;
    this.documentsRequestId++;
    this.resetPreview();
  },
  computed: {},
  methods: {
    isDocumentRequired(doc) {
      return doc?.doc_name?.required !== false;
    },
    async viewDoc(doc) {
      const url = doc?.doc_url;
      if (!url) return;
      this.resetPreview();
      const requestId = ++this.previewRequestId;
      this.previewDocName = doc?.doc_name?.name || "Document preview";
      this.isDocumentPreviewOpen = true;
      if (this.isImageUrl(url)) {
        this.previewType = "image";
        this.previewDocUrl = url;
        return;
      }
      this.previewLoading = true;
      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error("Document request failed");
        const buffer = await response.arrayBuffer();
        if (requestId !== this.previewRequestId) return;
        const contentType = response.headers.get("content-type") || "";
        const pathname = new URL(url, window.location.origin).pathname;
        await this.renderPreviewBuffer(buffer, pathname, contentType, requestId);
      } catch (error) {
        if (requestId === this.previewRequestId) {
          this.previewError = "Unable to preview this file. Please try again later.";
        }
      } finally {
        if (requestId === this.previewRequestId) this.previewLoading = false;
      }
    },
    async renderPreviewBuffer(buffer, filename, contentType, requestId) {
      const signature = new TextDecoder("ascii").decode(buffer.slice(0, 4));
      const isPdf = /\.pdf$/i.test(filename) ||
        /application\/pdf/i.test(contentType) || signature === "%PDF";
      const isDocx = /\.docx$/i.test(filename) ||
        /application\/vnd\.openxmlformats-officedocument\.wordprocessingml\.document/i.test(contentType);
      const isImage = /\.(png|jpe?g|gif|webp|bmp|svg)$/i.test(filename) ||
        /^image\//i.test(contentType);

      if (isPdf || isImage) {
        this.previewType = isPdf ? "pdf" : "image";
        this.previewObjectUrl = URL.createObjectURL(
          new Blob([buffer], { type: isPdf ? "application/pdf" : contentType })
        );
        this.previewDocUrl = this.previewObjectUrl;
      } else if (isDocx) {
        const result = await mammoth.convertToHtml({ arrayBuffer: buffer });
        if (requestId !== this.previewRequestId) return;
        this.previewType = "docx";
        this.previewHtml = DOMPurify.sanitize(result.value, {
          USE_PROFILES: { html: true },
        }) || "This document has no previewable content.";
      } else {
        this.previewError = "This file type cannot be previewed here.";
      }
    },
    isImageUrl(url) {
      if (!url || typeof url !== "string") return false;

      // Support normal image URLs and data URLs.
      if (url.startsWith("data:image/")) return true;

      try {
        const pathname = new URL(url, window.location.origin).pathname;
        return /\.(png|jpe?g|gif|webp|bmp|svg)$/i.test(pathname);
      } catch (error) {
        // Fallback for relative/unusual URLs.
        const cleanUrl = url.split("?")[0].split("#")[0];
        return /\.(png|jpe?g|gif|webp|bmp|svg)$/i.test(cleanUrl);
      }
    },
    handleImagePreviewError() {
      this.previewError = "Unable to preview this image. Use Download to open it.";
    },
    closePreview() {
      this.isDocumentPreviewOpen = false;
      this.previewRequestId++;
      this.resetPreview();
    },
    onPreviewDialogChange(isOpen) {
      if (!isOpen) {
        this.previewRequestId++;
        this.resetPreview();
      }
    },
    resetPreview() {
      this.clearPreviewContent();
      this.previewDocName = "";
      this.previewLoading = false;
    },
    clearPreviewContent() {
      if (this.previewObjectUrl) URL.revokeObjectURL(this.previewObjectUrl);
      this.previewDocUrl = "";
      this.previewType = "";
      this.previewHtml = "";
      this.previewError = "";
      this.previewObjectUrl = "";
    },
    openDoc(docurl) {

      if (docurl) {
        this.loader = true;
        this.SelectedSrc = docurl;
        const url = docurl;
        const link = document.createElement("a");
        link.href = url;
        const filename = decodeURIComponent(
          new URL(url, window.location.origin).pathname.split("/").pop()
        ) || "document";
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        this.loader = false;
        // this.isshowdoc = true;
      } else {
        return "";
      }
    },
    async getuploads() {
      if (!this.$route.query.login_id || !this.$route.query.customer_id || !this.isActive) return;
      const requestId = ++this.documentsRequestId;
      this.loader = true;
      try {
        const response = await AgentService.getUploadBusDocs({
          login_id: this.$route.query.login_id,
          customer_id: this.$route.query.customer_id,
        });
        if (requestId !== this.documentsRequestId) return;
        if (Number(response?.data?.status_code) !== 200) {
          throw new Error(response?.data?.message || "Unable to load documents.");
        }
        this.docsupload = response.data?.data?.[0] || {};
        this.EntityDocs = (this.EntityDocs || []).map((doc) => ({
          doc_name: doc.doc_name,
          doc_val: null,
          doc_url: this.docsupload[doc.doc_name.code] || null,
          isactive: false,
        }));
      } catch (error) {
        if (requestId === this.documentsRequestId) {
          this.alertMsg = {
            ...this.alertMsg,
            status: true,
            text: error?.message || "Unable to load documents. Please try again.",
            type: "error",
            color: "error",
          };
        }
      } finally {
        if (requestId === this.documentsRequestId) this.loader = false;
      }
    },
    async uploadDocument(doc) {
      if (this.loader) return;
      const isRequired = this.isDocumentRequired(doc);
      if (!(doc.doc_val instanceof Blob)) {
        if (doc.doc_url || !isRequired) {
          this.docError = "";
          this.error = false;
          doc.isactive = false;
        } else {
          this.docError = "Document is required";
        }
        return;
      }
      this.docError = "";
      this.loader = true;
      this.alertMsg.status = false;
      try {
        const fileData = new FormData();
        fileData.append("document", doc.doc_val);
        const response = await AgentService.UploadBusDocs(fileData, {
          login_id: this.$route.query.login_id,
          customer_id: this.$route.query.customer_id,
          type: doc.doc_name.value,
          doc_type: doc.doc_name.value_code,
        });
        if (!(response?.data?.success || Number(response?.data?.status_code) === 200)) {
          throw new Error(response?.data?.message || "Document upload failed.");
        }
        doc.isactive = false;
        await this.getuploads();
        this.alertMsg = {
          ...this.alertMsg,
          status: true,
          text: this.$t("file_uploaded_successfully"),
          type: "success",
          color: "green",
        };
      } catch (error) {
        this.alertMsg = {
          ...this.alertMsg,
          status: true,
          text: error?.message || "Document upload failed. Please try again.",
          type: "error",
          color: "error",
        };
      } finally {
        this.loader = false;
      }
    },
    fileUpload(event, doc) {
      if (event && event.name) {

        this.docError = "";
        this.error = false;
      } else if (!this.isDocumentRequired(doc)) {
        this.docError = "";
        this.error = false;
      } else {
        this.docError = "Document is required";
        this.error = true;
      }
    },
    open() {
      this.$refs.selfiefile.$el.querySelector("input").click();
    },
    returnBusinessDocs(val, documents) {
      this.EntityDocs = (documents[val] || [])
        .filter((doc) => val !== "Private Limited Companies (Sdn Bhd)" || doc.code !== this.hideForm)
        .map((doc) => ({
          doc_name: doc,
          doc_val: null,
          doc_url: null,
          isactive: false,
        }));
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/global.scss";

.invalid-feedback-name {
  display: flex;
  flex-direction: column;
  text-align: initial;
  font-size: 13px;
  background-color: #f5f5f5;
  color: #dc3545;
}

.document-preview-container {
  min-height: 220px;
  max-height: 75vh;
  overflow: auto;
  padding: 16px !important;
}

.preview-pdf {
  display: block;
  width: 100%;
  height: 70vh;
  border: 0;
}

.preview-word {
  overflow-wrap: anywhere;
}

.preview-word ::v-deep img {
  max-width: 100%;
  height: auto;
}

.preview-image {
  display: block;
  max-width: 100%;
  max-height: 70vh;
  width: auto;
  height: auto;
  object-fit: contain;
}
</style>
